var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeNone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 944,
    height: 32,
    viewBox: "0 0 944 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.53125,
    y: 0.508301,
    width: 943.465,
    height: 31.1818,
    rx: 15.5909,
    fill: "url(#paint0_linear_848_1900)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_848_1900",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 944,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.104492,
    width: 944,
    height: 31.3115,
    rx: 15.6558,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_848_1900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.892 0.104492H63.1967L22.3047 31.416H0L40.892 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3138 0.104492H108.619L67.7266 31.416H45.4219L86.3138 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.742 0.104492H154.046L113.154 31.416H90.8496L131.742 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.16 0.104492H199.464L158.572 31.416H136.268L177.16 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.581 0.104492H244.886L203.994 31.416H181.689L222.581 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.009 0.104492H290.314L249.422 31.416H227.117L268.009 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.431 0.104492H335.736L294.844 31.416H272.539L313.431 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.857 0.104492H381.162L340.27 31.416H317.965L358.857 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.275 0.104492H426.579L385.688 31.416H363.383L404.275 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.699 0.104492H472.003L431.111 31.416H408.807L449.699 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.12 0.104492H517.425L476.533 31.416H454.229L495.12 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.542 0.104492H562.847L521.955 31.416H499.65L540.542 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.962 0.104492H608.267L567.375 31.416H545.07L585.962 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.388 0.104492H653.693L612.801 31.416H590.496L631.388 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.812 0.104492H699.117L658.225 31.416H635.92L676.812 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.23 0.104492H744.535L703.643 31.416H681.338L722.23 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.656 0.104492H789.96L749.068 31.416H726.764L767.656 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.074 0.104492H835.378L794.486 31.416H772.182L813.074 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.503 0.104492H880.808L839.916 31.416H817.611L858.503 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.923 0.104492H926.228L885.336 31.416H863.031L903.923 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.345 0.104492H971.65L930.758 31.416H908.453L949.345 0.104492Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_848_1900",
    x1: 472.264,
    y1: 0.508301,
    x2: 472.264,
    y2: 31.6901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B7E6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeNone);
export default __webpack_public_path__ + "static/media/time-none.721a9db7c163d83ded3a6a6e874c9c89.svg";
export { ForwardRef as ReactComponent };